module.exports = __webpack_public_path__ + "img/pethouse23.290e73a9.jpg";